/*!
 * el-table-infinite-scroll v3.0.3
 * (c) 2019-2023 yujinpan
 */

import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.for-each.js';

/**
 * sync element attrs
 */
function syncAttrs(sourceElem, targetElem, attrsKeys) {
  var value;
  attrsKeys.forEach(function (name) {
    value = sourceElem.getAttribute(name);
    if (value !== null) {
      targetElem.setAttribute(name, value);
    } else {
      targetElem.removeAttribute(name);
    }
  });
}

export { syncAttrs };
